import { Header } from "../../components/Header";
import ArrowDoubleSide from "../../components/icons/ArrowDoubleSide";
import Logo from "../../components/icons/Logo";
import "./index.scss";
const AboutUs = () => {
    return (
      <div className="page splash aboutUsPage">
        <div className="background" />
        <Header />
        <div className="logo">
            <Logo />
        </div>
        <div className="triple-text">
            <span>Food Service{'\n'}</span>
            <span>Software Technology{'\n'}</span>
            <span>for Business & Industry</span>
        </div>
        <div className="bottom-bar">
          <span>
            Agilysys offers the broadest portfolio of Business &{'\n'}
            Industry solutions with the deepest functionality in the{'\n'}
            market, delighting diners and empowering staff to{'\n'}
            provide exceptional service at every touchpoint.
          </span>
        </div>
        <img className="bubbles" src="https://storage.googleapis.com/popshap-kiosks-dev.appspot.com/agilysys/aboutAgilysysBusinessIndustry.png"/>
      </div>
    );
}
export default AboutUs;